export default __webpack_public_path__ + "6d33eda64dcd6b52a87722199dae11d2.jpg";